export const fields2 =  [
    // {
    //     "id": "exposure",
    //     "title": "Exposure",
    //     "questions": [
    //         {
    //             "id": "exposure",
    //             "type": "button-switch",
    //             "title": "",
    //             "options": [
    //                 {
    //                     "id": "1",
    //                     "title": "Original",
    //                     "checked": true
    //                 },
    //                 {
    //                     "id": "2",
    //                     "title": "Customised",
    //                     "checked": false
    //                 }
    //             ],
    //             "required": false 
    //         },
    //         {
    //             "id": "newDbValue",
    //             "type": "number",
    //             "title": "Notional dB(A) LEP’D Level exposed",
    //             "validation": {
    //                 "max": 125,
    //                 "min": 85
    //             },
    //             "required": true,
    //             "errorMessage": "Input a value between 85 and 125"
    //         }
    //     ]
    // },
    {
        "id": "arhlParam",
        "title": "Modifiers",
        "questions": [
            {
                "id": "arhlParam",
                "type": "button-switch",
                "title": "",
                "options": [
                    {
                        "id": "1",
                        "title": "Best Fit",
                        "checked": true
                    },
                    {
                        "id": "2",
                        "title": "Customised",
                        "checked": false
                    }
                ],
                "required": false 
            },
            {
                "id": "changeAgeTo",
                "type": "number",
                "title": "Age",
                "required": true,
                "validation": {
                    "max": 95,
                    "min": 5
                },
                "errorMessage": "Input a age from the 5th to the 95th"
            },
            {
                "id": "changeCentileTo",
                "type": "number",
                "title": "Centile",
                "required": true,
                "validation": {
                    "max": 95,
                    "min": 5
                },
                "errorMessage": "Input a centile from the 5th to the 95th"
            }
        ]
    },
    {
        "id": "anchor",
        "title": "Anchor",
        "questions": [
            {
                "id": "changeAnchorPoints",
                "type": "switch",
                "title": "Change Anchor Points",
                "options": [
                    {
                        "id": "yes",
                        "title": "Yes"
                    },
                    {
                        "id": "no",
                        "title": "No"
                    }
                ],
                "required": false
            },
            {
                "id": "newUpperAnchor",
                "type": "dropdown",
                "title": "New Upper Anchor",
                "options": [
                    {
                        "id": "6000",
                        "title": "6000"
                    },
                    {
                        "id": "8000",
                        "title": "8000"
                    }
                ],
                "required": false
            },
            {
                "id": "newLowerAnchor",
                "type": "dropdown",
                "title": "New Lower Anchor",
                "options": [
                    {
                        "id": "500",
                        "title": "500"
                    },
                    {
                        "id": "1000",
                        "title": "1000"
                    },
                    {
                        "id": "2000",
                        "title": "2000"
                    }
                ],
                "required": false
            }
        ]
    }
]